/*
 * ─── ASSET CONFIGURATION — ALL 11 FILMS ───
 * UTM format: ?utm_source=avinash-studio&utm_medium=film-world&utm_campaign={slug}
 * Poster images: gold-gradient placeholders until AT uploads real posters
 */

function utm(url, slug) {
  if (!url) return '';
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}utm_source=avinashtiwary.com&utm_medium=film_worlds&utm_campaign=fan_meet_apr23&utm_content=${slug}`;
}

export const HERO = {
  image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/fia5egs9_5461498A-5D71-4307-AECE-DF17C0930091.jpeg",
  alt: "Avinash Tiwary",
};

export const NOW_SHOWING = {
  title: "Ginny Weds Sunny 2",
  year: "2026",
  role: "Sunny",
  director: "Prasshant Jha",
  coStar: "Medha Shankr",
  studio: "Zee Studios · Soundrya Production",
  music: "Sony Music",
  status: "In cinemas from Apr 24, 2026",
  tagline: "Sacchi-Jhoothi Love Story",
  description: "Sacchi-Jhoothi Love Story. In cinemas from Apr 24, 2026.",
  image: "/films/ginny-weds-sunny-2-poster.jpg",
  imdb: "https://www.imdb.com/title/tt36277018/",
  links: {
    trailer: "https://www.youtube.com/watch?v=HGCBJ9Qs6Bk",
    bms: utm("https://in.bookmyshow.com/explore/movies?q=Ginny+Weds+Sunny+2", "gws2-release"),
  },
};

export const FILMS = [
  // ── NEW RELEASES (top) ──
  {
    title: "Ginny Weds Sunny 2",
    year: "2026",
    role: "Sunny",
    director: "Prasshant Jha",
    coStar: "Medha Shankr",
    description: "Sacchi-Jhoothi Love Story",
    mood: "rgba(50, 40, 15, 0.95)",
    status: "In cinemas from Apr 24, 2026",
    studio: "Zee Studios · Soundrya Production",
    music: "Sony Music",
    image: "/films/ginny-weds-sunny-2-poster.jpg",
    imdb: "https://www.imdb.com/title/tt36277018/",
    links: {
      trailer: "https://www.youtube.com/watch?v=HGCBJ9Qs6Bk",
      bms: utm("https://in.bookmyshow.com/explore/movies?q=Ginny+Weds+Sunny+2", "gws2-release"),
    },
    stills: [],
  },
  {
    title: "O Romeo",
    year: "2026",
    role: "Jalal",
    director: "Vishal Bhardwaj",
    description: "What Shakespeare started, we finish differently.",
    mood: "rgba(30, 15, 20, 0.95)",
    status: "In cinemas from Feb 13, 2026",
    image: "/films/o-romeo-poster.jpg",
    imdb: "https://www.imdb.com/title/tt31969779/",
    links: {
      trailer: "https://youtu.be/2M4hKmuBzUU",
    },
    stills: [],
  },
  // ── 2024 ──
  {
    title: "Sikandar Ka Muqaddar",
    year: "2024",
    role: "Sikandar Sharma",
    director: "Neeraj Pandey",
    description: "Every heist has a ghost.",
    mood: "rgba(20, 20, 30, 0.95)",
    award: "Iconic Best Actor 2024",
    image: "/films/sikandar-ka-muqaddar-poster.jpg",
    imdb: "https://www.imdb.com/title/tt31522415/",
    links: {
      trailer: "https://www.youtube.com/watch?v=incbkkV-6vA",
      netflix: utm("https://www.netflix.com/title/81750030", "sikandar-ka-muqaddar"),
    },
    stills: [],
  },
  {
    title: "The Mehta Boys",
    year: "2024",
    role: "Amay Mehta",
    director: "Boman Irani",
    description: "Fathers and sons. The things we inherit and the things we choose.",
    mood: "rgba(25, 25, 20, 0.95)",
    award: "Jury nom — Breakthrough Performance 2024",
    image: "/films/the-mehta-boys-poster.jpg",
    imdb: "https://www.imdb.com/title/tt31897917/",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=bD5Zd0KWLqA", "mehta-boys"),
      prime: utm("https://www.primevideo.com/detail/The-Mehta-Boys/0RBEI5519KDCZ4VI9QLR6LS9AJ", "mehta-boys"),
    },
    stills: [],
  },
  {
    title: "Madgaon Express",
    year: "2024",
    role: "",
    director: "Kunal Khemu",
    description: "Some journeys are funnier than the destination.",
    mood: "rgba(15, 30, 25, 0.95)",
    image: "/films/madgaon-express-poster.jpg",
    imdb: "",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=B7VP47oCZfE", "madgaon-express"),
      prime: utm("https://www.primevideo.com/detail/Madgaon-Express/0H6R2109H0N7KG2BX6IHF1KEHD", "madgaon-express"),
    },
    stills: [],
  },
  // ── 2023 ──
  {
    title: "Bambai Meri Jaan",
    year: "2023",
    role: "Dara Kadri",
    director: "Shujaat Saudagar",
    description: "The city that makes and unmakes everyone.",
    mood: "rgba(35, 25, 15, 0.95)",
    image: "/films/bambai-meri-jaan-poster.jpg",
    imdb: "",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=mkTcLd3b_Us", "bambai-meri-jaan"),
      prime: utm("https://www.primevideo.com/detail/Bambai-Meri-Jaan/0KB9Z3A0RB9Z00PXBCWJ2JKXBQ", "bambai-meri-jaan"),
    },
    stills: [],
  },
  {
    title: "Kaala",
    year: "2023",
    role: "Ritwik (IB Officer)",
    director: "Bejoy Nambiar",
    description: "Some operations never end.",
    mood: "rgba(15, 15, 25, 0.95)",
    image: "/films/kaala-poster.jpg",
    imdb: "https://www.imdb.com/title/tt28744346/",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=j7kXbtmhxxc", "kaala"),
      hotstar: utm("https://www.hotstar.com/in/shows/kaala/1260148381", "kaala"),
    },
    stills: [],
  },
  // ── 2022 ──
  {
    title: "Khakee",
    subtitle: "The Bihar Chapter",
    year: "2022",
    role: "Chandan Mahto",
    director: "Neeraj Pandey & Bhav Dhulia",
    description: "The ground beneath power. Where law meets dust.",
    mood: "rgba(25, 20, 15, 0.95)",
    award: "Star Eminence 2023",
    image: "/films/khakee-poster.jpg",
    imdb: "",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=XneHBxjMg_Y", "khakee"),
      netflix: utm("https://www.netflix.com/title/81290872", "khakee"),
    },
    stills: [],
  },
  // ── 2020 ──
  {
    title: "Bulbbul",
    year: "2020",
    role: "Satyajeet (Satya)",
    director: "Anvita Dutt",
    description: "Darkness has its own kind of beauty. This was mine.",
    mood: "rgba(15, 15, 35, 0.95)",
    image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/lmhoy425_Satya_03.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/6sitbrks_ABP_5860.jpg",
      "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/lmhoy425_Satya_03.png",
      "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/esv4cds1_TUS-2.png",
      "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/d2k03jag_TUS-8.png",
    ],
    imdb: "",
    links: {
      trailer: utm("https://youtu.be/4MGReT9-cAg", "bulbbul"),
      netflix: utm("https://www.netflix.com/title/81029150", "bulbbul"),
    },
    stills: [],
  },
  // ── 2018 ──
  {
    title: "Laila Majnu",
    year: "2018",
    role: "Qais (Majnu)",
    director: "Sajid Ali",
    description: "A love that consumed everything. The role that broke me open.",
    mood: "rgba(50, 30, 15, 0.95)",
    image: "/laila/page-04.png",
    poster: "/laila/page-03.png",
    imdb: "",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=Cv-6cAHanZ8", "laila-majnu"),
      netflix: utm("https://www.netflix.com/title/81988312", "laila-majnu"),
      prime: utm("https://www.primevideo.com/detail/Laila-Majnu/0RGQV8VRMGC0GXMXBHLCY67ABN", "laila-majnu"),
    },
    stills: [],
  },
  // ── 2017 ──
  {
    title: "Tu Hai Mera Sunday",
    year: "2017",
    role: "Rashid",
    director: "Milind Dhaimade",
    description: "Five friends. One football field. The joy of just being.",
    mood: "rgba(45, 35, 20, 0.95)",
    image: "/films/tu-hai-mera-sunday-poster.jpg",
    imdb: "",
    links: {
      trailer: utm("https://www.youtube.com/watch?v=b1Q_r-2Y5R4", "tu-hai-mera-sunday"),
      hotstar: utm("https://www.hotstar.com/in/movies/tu-hai-mera-sunday/1770017021/watch", "tu-hai-mera-sunday"),
    },
    stills: [],
  },
];

export const NOW = { image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/bgvb9t31_9CD78097-A8E1-4665-AE09-EC378065E18D.jpeg", alt: "Avinash Tiwary — Now" };
export const INSIDE = { image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/jseoarto_DSC_6167.jpeg", alt: "Inside" };
export const BEYOND = { image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/vesfy3yi_DSC_6170.jpeg" };

export const SOCIAL = {
  instagram: "https://www.instagram.com/avinashtiwary15/",
  youtube: "https://www.youtube.com/@AvinashTiwary",
  imdb: "https://www.imdb.com/name/nm6433685/",
};

export const WATCH_TOGETHER = { enabled: false };
